<script setup>

const props = defineProps({
  data: Object,
});
const expanderId = 'expander-' + (Math.floor(Math.random() * (1000 - 0)))
const accordions = ref([]);
const allClosed = ref(true);

const toggleAccordion = (event) => {
  let target = event.target

  // get unique class name for this expander
  let collapseClass = target.getAttribute('collapse-items')
  let items = document.getElementsByClassName(collapseClass)

  // Change expand/close all button
  if (allClosed.value) {
    target.classList.remove('active')
    allClosed.value = false
  } else {
    target.classList.add('active')
    allClosed.value = true
  }

  for (let index in items){
    if (typeof(items[index]) == 'object') {
      const collapseInstance = bootstrap.Collapse.getOrCreateInstance(items[index]);
      // Validate if cards were closed or opened
      if (allClosed.value) {
        collapseInstance.hide();
      } else {
        collapseInstance.show();
      }
    }
  }
}


const scrollToAccordion = (i) => {
  accordions.value.forEach((accordion) => {
    const headingEl = accordion.querySelector(`#heading-${i}`);
    if (headingEl) {
      headingEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.scrollBy(0, -100);
    }
  });
};

</script>


<template>
  <div class="block expander">
    <div class="container">
      <div :class="['accordion', data.faq ? 'faq' : '']" :id="`${expanderId}`">
        <div :class="[!data.faq && 'vertical-gradient vertical-gradient--inner ms-1 ps-4']">
          <div class="card" v-for="(expander, i) in data.expander" :key="expander.id">
            <div class="card-header" :id="`heading-${i}`">
              <div class="card-title">
                <a role="button" class="collapsed" data-bs-toggle="collapse" :data-bs-target="`#${expanderId}-collapse-${i}`"
                    aria-expanded="false" :aria-controls="`expander-collapse-${i}`">
                  <div class="icon-container">
                      <div class="bi bi-plus"></div>
                  </div>
                  <div class="content">
                      <h2>{{ expander.title }}</h2>
                  </div>
                </a>
              </div>
            </div>
            <div :id="`${expanderId}-collapse-${i}`" :class="`collapse collapse-${expanderId}`" :aria-labelledby="`heading-${i}`">
                <div class="card-body" v-html="expander.description"></div>
            </div>
            <div class="divider"></div>
          </div>
        </div>
        
        <div class="expand-all">
          <a class="toggle-accordion active" :collapse-items="`collapse-${expanderId}`" role="button" @click="toggleAccordion"></a>
        </div>
    </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .accordion {

    &.faq {
      .card {
        h2 {
          font-size: 14px;
          font-weight: normal;
        }

        .card-body {
          font-size: 14px;
        }

        .card-header a .icon-container .bi-plus {
          &:before {
            color: black;
          }
        }
      }

      .expand-all {
        display: none;
      }
    }

    .expand-all {
      padding: 20px 40px;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
       
       a {
         text-decoration: none;
       }
    }

    .toggle-accordion.active:before {
      content: "Expand all info";
    }

    .toggle-accordion:before {
      content: "Close all info";
    }

    .card {
      border: 0;

      .divider {
        border-bottom: solid 1px #e8e8e8;
        margin: 0 40px;
      }

    .card-header {
        padding: 0px;
        background-color: unset;
        border-bottom: unset;

        .card-title {
          margin-bottom: 0;
        }

        .collapse{
          transition: 0.5s;
        }

        a {
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-decoration: none;

          .icon-container {
            width: 30px;

            .bi-plus {
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 1.5rem;

              &:before {
                color: rgb(11,204,138);
                -webkit-transform: rotate(45deg);
              }
            }
          }

          .content {
            width: calc(100% - 30px);
            padding: 20px 0;

            h2 {
              font-size: 1rem;
              margin-top: 0;
              padding-bottom: 0;
              margin-left: 10px;
            }
          }
        }

        [data-bs-toggle="collapse"].collapsed .bi-plus:before {
          -webkit-transform: rotate(180deg);
        }
      }
      .card-body {
        padding: 0px 40px;
      }
    }
  }
</style>